import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=ae0763ee&"
import script from "./MessageItem.vue?vue&type=script&lang=ts&"
export * from "./MessageItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports